import {
    useContext,
} from 'react';

import {
    SettingProvider,
    SettingContext,
    SettingProviderValue,
} from './components';

export const useSetting = (): SettingProviderValue => useContext(SettingContext);

export { SettingProvider };
